'use client';
/** @jsxImportSource @emotion/react */

import { forwardRef, type ElementType, type Ref } from 'react';

import {
  type OverridableComponent,
  type OverrideProps,
} from '@mui/material/OverridableComponent';
import MuiPaper, { type PaperTypeMap } from '@mui/material/Paper';

type ExcludedMuiProps = 'square';
type CustomProps = {
  component?: ElementType;
};

type ZeusPaperTypeMap<
  P = CustomProps,
  D extends ElementType = PaperTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<PaperTypeMap['props'], ExcludedMuiProps> & P;
};

/**
 * @deprecated Please use `Surface` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-surface-migration--surface-migration-guide Migration guide}
 */
export type PaperProps<
  D extends ElementType = PaperTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<PaperTypeMap<P, D>, D>;

const PaperComponent = (props: PaperProps, ref: Ref<HTMLDivElement>) => {
  return <MuiPaper {...props} ref={ref} />;
};

PaperComponent.displayName = 'Paper';

/**
 * @deprecated Please use `Surface` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-surface-migration--surface-migration-guide Migration guide}
 */
export const Paper = forwardRef(
  PaperComponent
) as OverridableComponent<ZeusPaperTypeMap>;
